import styled from "styled-components";

export const MusicHallBookingDetailContainerStyled = styled.div``;
